import { ServiceRejection } from '../../types';
import { useLanguage } from '../../i18n/LanguageContext';

interface RejectionReasonsModalProps {
  rejections: ServiceRejection[];
  onClose: () => void;
}

function RejectionReasonsModal({ rejections, onClose }: RejectionReasonsModalProps) {
  const { t } = useLanguage();

  return (
    <div className="partner-modal-overlay" onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}>
      <div className="partner-modal" style={{ maxWidth: '600px' }}>
        <div className="partner-modal-header">
          <h2>{t('services.modal.rejectionTitle')}</h2>
          <button className="partner-modal-close" onClick={onClose}>&times;</button>
        </div>

        <div className="partner-modal-body">
          {rejections.length === 0 ? (
            <p style={{ color: '#6b7280', textAlign: 'center', padding: '1rem' }}>
              {t('services.modal.noRejections')}
            </p>
          ) : (
            <table className="partner-rejection-table">
              <thead>
                <tr>
                  <th>{t('services.modal.serviceName')}</th>
                  <th>{t('services.modal.rejectionReason')}</th>
                </tr>
              </thead>
              <tbody>
                {rejections.map((item, index) => (
                  <tr key={index}>
                    <td style={{ fontWeight: 500 }}>{item.serviceName}</td>
                    <td>{item.rejectionReason}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        <div className="partner-modal-footer">
          <button className="partner-modal-btn-cancel" onClick={onClose}>
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default RejectionReasonsModal;
